// react redux
import { useSelector } from "react-redux";
// components
import NavItem from "./NavItem/NavItem";

const NavMenu = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <ul className="my-3">
      <NavItem
        destination={isAuthenticated ? "/categories" : "/login"}
        content={isAuthenticated ? "تصفح الأقسام" : "تسجيل الدخول"}
        visibleOnMobileOnly
      />
      <NavItem destination="/#welcome" content="الرئيسية" uniqueId="الرئيسية" />
      <NavItem
        destination="/#whyMtor"
        content="لماذا موتور؟"
        uniqueId="لماذا موتور؟"
      />
      <NavItem
        destination="/#mtorApps"
        content="الموردين"
        uniqueId="الموردين"
      />
      <NavItem
        destination="/#mtorApps"
        content="مراكز الخدمة"
        uniqueId="مراكز الخدمة"
      />
    </ul>
  );
};

export default NavMenu;
